"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLoanProductParams = void 0;

const createLoanProductParams = ({
  intendedCredit
}) => ({
  'valor-emprestimo': intendedCredit
});

exports.createLoanProductParams = createLoanProductParams;